import { useCallback, useEffect, useRef } from "react";

const HEADER_HEIGHT = 60;
const ACTIVATION_ZONE = 100;
const MIN_SPEED = 4;
const MAX_SPEED = 18;

const useDragScrollUp = (getScrollElement: () => HTMLElement | null) => {
    const pointerY = useRef<number | null>(null);
    const frame = useRef<number | null>(null);

    const stop = useCallback(() => {
        pointerY.current = null;
        if (frame.current !== null) {
            cancelAnimationFrame(frame.current);
            frame.current = null;
        }
    }, []);

    const scroll = useCallback(() => {
        frame.current = null;
        const element = getScrollElement();
        const y = pointerY.current;
        if (!element || y === null || element.scrollTop <= 0)
            return;

        const top = element.getBoundingClientRect().top + HEADER_HEIGHT;
        const distance = y - top;
        if (distance > ACTIVATION_ZONE)
            return;

        const ratio = Math.min(1, Math.max(0, (ACTIVATION_ZONE - distance) / ACTIVATION_ZONE));
        element.scrollTop -= MIN_SPEED + (MAX_SPEED - MIN_SPEED) * ratio;
        frame.current = requestAnimationFrame(scroll);
    }, [getScrollElement]);

    const onDragMove = useCallback((event: any) => {
        pointerY.current = event.operation.position?.current?.y ?? null;
        if (frame.current === null)
            frame.current = requestAnimationFrame(scroll);
    }, [scroll]);

    useEffect(() => stop, [stop]);

    return { onDragMove, stopDragScrollUp: stop };
};

export default useDragScrollUp;
